import api from "./apiConfig";

// api/apiAuth.js o donde esté definida
export const CHECK_SESSION = async () => {
	try {
		const response = await api.get("/me");


		if (response.status === 200 && response.data) {

			return response.data;
		} else {
			throw new Error("Sesión no válida.");
		}
	} catch (error) {
		console.error('CHECK_SESSION error:', error);
		throw error;
	}
};

export const LOGIN = async (values) => {
	try {
		const response = await api.post("/login", values);
		return response.data;
	} catch (error) {
		if (error.response.status === 401) {
			console.error(error);
		} else {
			console.error(error);
		}
		throw error;
	}
};

export const LOGOUT = async () => {
	try {
		const response = await api.get("/logout");
		return response.data;
	} catch (error) {
		console.error("Error al cerrar sesión:", error);
		throw error;
	}
};
